import TasksService from 'aurora-composition/services/tasksService';
import * as types from './constants';

export const getMuncipality = id => {
  if (id === '1000') {
    return {
      en: 'Abu Dhabi City',
      ar: 'مدينة أبو ظبي',
    };
  }
  if (id === '1001') {
    return {
      en: 'Al Ain City',
      ar: 'مدينة العين',
    };
  }
  if (id === '1002') {
    return {
      en: 'Al Dhafra Region',
      ar: 'منطقة الظفرة',
    };
  }

  return {
    en: 'Abu Dhabi City',
    ar: 'مدينة أبو ظبي',
  };
};
export const fetchTaskSuccess = tasks => {
  const { isFetchingNavbarTasks, ...data } = tasks;
  if (isFetchingNavbarTasks)
    return {
      type: types.FETCH_TASKS_FOR_NAVBAR_COMPONENT_SUCCESS,
      payload: {
        tasks: data,
      },
    };

  return {
    type: types.FETCH_TASKS_SUCCESS,
    payload: {
      tasks: data,
    },
  };
};

export const fetchTaskError = error => ({
  type: types.FETCH_TASKS_ERROR,
  payload: {
    error,
  },
});

export const fetchTask = data => async dispatch => {
  const { filter = '', page = 0, size = 5, isFetchingNavbarTasks = false } = data;
  try {
    dispatch({ type: types.FETCH_TASKS });
    const response = await TasksService.fetchTask(filter, page, size || {});
    const res = response?.data?.result || response?.result;
    dispatch(
      fetchTaskSuccess({
        data: res?.tasks,
        page: {},
        pageNumber: page,
        totalPages: res?.totalPages,
        totalRecord: res?.recordsTotal,
        isFetchingNavbarTasks,
      }),
    );
  } catch (e) {
    dispatch(fetchTaskError(e));
  }
};

export const fetchOffplanTerminationTask = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFF_PLAN_TERMINATION_TASK_LIST });
    const response = await TasksService.fetchOffplanTerminationTask();
    if (response?.success) {
      dispatch({
        type: 'FETCH_OFF_PLAN_TERMINATION_TASK_LIST_SUCCESS',
        payload: { terminationTasks: response?.result },
      });
    }
  } catch (e) {
    dispatch(fetchTaskError(e));
  }
};

export const fetchTaskList = data => async dispatch => {
  try {
    const { filters = {}, page = 0, size = 5 } = data;
    dispatch({ type: types.FETCH_TASKS });
    const response = await TasksService.fetchTaskList(page, size, filters);
    const res = response?.data?.result || response?.result;
    dispatch(
      fetchTaskSuccess({
        data: res?.tasks,
        page: {},
        pageNumber: page,
        totalPages: res?.totalPages,
        totalRecord: res?.recordsTotal,
      }),
    );
  } catch (e) {
    dispatch(fetchTaskError(e));
  }
};
